import { useTranslation } from 'react-i18next';

interface HoursProgressBarProps {
  actual: number;
  estimated: number;
  showLabel?: boolean;
  className?: string;
}

export default function HoursProgressBar({ actual, estimated, showLabel = true, className = '' }: HoursProgressBarProps) {
  const { t } = useTranslation();

  if (estimated <= 0) {
    return showLabel ? (
      <div className={`text-xs text-surface-500 ${className}`}>{Number(actual ?? 0).toFixed(1)} {t('common.hoursShort')} {t('charts.noEstimate')}</div>
    ) : null;
  }

  const actualNum = Number(actual ?? 0);
  const estimatedNum = Number(estimated ?? 0);
  const pct = Math.min((actualNum / estimatedNum) * 100, 100);
  const overflowPct = actualNum > estimatedNum ? ((actualNum - estimatedNum) / estimatedNum) * 100 : 0;

  let barColor = 'bg-success-500';
  if (pct >= 90) barColor = 'bg-danger-500';
  else if (pct >= 70) barColor = 'bg-warning-500';

  return (
    <div className={className}>
      <div className="w-full bg-surface-200 rounded-full h-2 overflow-hidden">
        <div className={`h-2 rounded-full transition-all ${barColor}`} style={{ width: `${Math.min(pct, 100)}%` }} />
      </div>
      {showLabel && (
        <div className="flex justify-between items-center mt-1">
          <span className="text-xs text-surface-500">{actualNum.toFixed(1)} / {estimatedNum.toFixed(1)} {t('common.hoursShort')}</span>
          <span className={`text-xs font-medium ${pct >= 90 ? 'text-danger-700' : pct >= 70 ? 'text-warning-700' : 'text-success-700'}`}>
            {pct.toFixed(0)}%
            {overflowPct > 0 && <span className="text-danger-700 ms-1">{t('charts.overflow')}</span>}
          </span>
        </div>
      )}
    </div>
  );
}
